import { baseApi, LoginApiResponse } from "../../../../core/data/rtk/baseQuery";
import { LoginFormData } from "../types/loginTypes";

export interface LoginResponseData {
  user: {
    id: number;
    username: string;
    role: string;
    status: string;
    center_id?: number;
  };
  token: string;
  expires_in: number;
}

export const loginApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginApiResponse<LoginResponseData>, LoginFormData>(
      {
        query: (credentials) => ({
          url: "login",
          method: "POST",
          body: credentials,
        }),
        transformResponse: (response: LoginApiResponse<LoginResponseData>) => {
          if (!response.success) {
            throw response;
          }
          return response;
        },
        transformErrorResponse: (response: LoginApiResponse) => ({
          success: false,
          status: response.status,
          message: response.message || "Login failed",
          error: response.error || "Authentication error",
          data: null,
        }),
      }
    ),
    logout: builder.mutation<LoginApiResponse<LoginResponseData>, void>({
      query: () => ({
        url: "logout",
        method: "POST",
      }),
      transformResponse: (response: LoginApiResponse<LoginResponseData>) => {
        if (!response.success) {
          throw response;
        }
        return response;
      },
      transformErrorResponse: (response: LoginApiResponse) => ({
        success: false,
        status: response.status,
        message: response.message || "Logout failed",
        error: response.error || "Authentication error",
        data: null,
      }),
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation } = loginApi;
